import { render, staticRenderFns } from "./DeviceDetailsDrawer.vue?vue&type=template&id=5f8c462c&scoped=true&"
import script from "./DeviceDetailsDrawer.vue?vue&type=script&lang=js&"
export * from "./DeviceDetailsDrawer.vue?vue&type=script&lang=js&"
import style0 from "./DeviceDetailsDrawer.vue?vue&type=style&index=0&id=5f8c462c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f8c462c",
  null
  
)

export default component.exports